import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { FileDrop } from "react-file-drop";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import flag from "../../../../Assets/Images/flag.png";
import { LocationContext } from "../../../../CustomHelper/Helper";
import SuccessfulDoneComp from "../SuccessfulDoneComp/UploadStatusView";
import "./LearningDragAndDrop.css";
import { serverInfo } from "../../../../App";
import useVdieoHandleS3 from '../../../../CustomHooks/useVideoHandleS3';
import MediaUploadProgressBar from "../../../../Screen/MediaUploadProgressBar";
import useLearningVideoUpload from "../../../../CustomHooks/useLearningVideoUpload";

const LearningDragAndDrop = ({ learningSessionData }) => {
  const { imageCdnUrl, videoCdnUrl } = useContext(serverInfo);
  const [error_list, setErrorList] = useState([]);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [learningSession, setLearningSession] = useState([]);

  console.log('learning test',learningSession);


  const { paymentCount, paymentCountWithSymbol, countryDate } = useContext(LocationContext);
  const [videoUrls, videoKeys, videoProgress, setFiles, setDeleteFile, setProgress] = useLearningVideoUpload();


  useEffect(() => {
    setLearningSession(learningSessionData);
  }, [learningSessionData]);

  const fileInputRef = useRef(null);

  const slots = learningSession.assignment_video_slot_number;


  const onFileInputChange = async (file) => {
    setProgress(0)
    setFiles(file)
  };

  const uploadVideo = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("learning_session_id", learningSession.id);

    if (
      videoKeys.length === Number(learningSession.assignment_video_slot_number)
    ) {
      setUploadLoading(true);
      videoKeys.forEach((image_file) => {
        formData.append("file[]", image_file);
      });
    } else {
      swal(
        "Error",
        "Please Upload " +
        learningSession.assignment_video_slot_number +
        " Videos",
        "error"
      );
    }

    axios
      .post(`api/user/learning-session/video-upload`, formData)
      .then((res) => {
        if (res.data.status === 200) {
          setUploadLoading(false);
          setLearningSession(res?.data?.learningSession);
          setErrorList([]);
          setFiles('')
          swal("Success", res.data.message, "success");
        } else if (res.data.status === 422) {
          setErrorList(res.data.validation_errors);
        } else {
        }
      });
  };

  const onTargetClick = () => {
    fileInputRef.current.click();
  };
console.log('learningSession=========>',learningSession);
  return (
    <div>
      {learningSession &&
        learningSession.assignment_video_slot_number > 0 &&
        learningSession.learning_session_assignment?.length >=
        learningSession.assignment_video_slot_number ? (
        <>
          <SuccessfulDoneComp />
        </>
      ) : (
        <>
          <div className="dragAndDropBgRound mt-4">
            <div className="p-3">
              <div className="row">
                <div className="col-md-4 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light VideoSubmissionText">
                        Video Submission Start Date
                      </span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {learningSession.assignment_reg_start_date &&
                          countryDate(learningSession.assignment_reg_start_date)
                        }
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light VideoSubmissionText">
                        Video Submission End Date
                      </span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {learningSession.assignment_reg_end_date &&
                          countryDate(learningSession.assignment_reg_end_date)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light VideoSubmissionText">
                        Assignment Fee
                      </span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {paymentCountWithSymbol(learningSession?.assignment_fee)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="bottomLineGoldLearning"></div>
            {uploadLoading ? (
              <>
                <h1 className="text-light">Videos Uploading.....</h1>
              </>
            ) : (
              <>
                <div className="container-fluid py-4">
                  <div className="row">
                    <h4 className="text-light text-center">Uploaded Video: {videoKeys.length +'/'+slots}</h4>
                    {videoKeys.map((data, index) => (
                      <>
                        <div className="videoPlayerSection"></div>
                        <div className="my-2">
                          <span className="text-danger" onClick={() => setDeleteFile(data)}>X</span>
                          <ReactPlayer
                            url={data != null ? videoCdnUrl + data : null}
                            controls={true}
                            playing={false}
                            volume={1}
                            style={{ margin: "0 auto" }}
                            height={130}
                            width={210}
                          />
                        </div>
                        <div className="videoPlayerSection"></div>
                      </>
                    ))}
                  </div>
                  <div className="row my-3 d-flex justify-content-center">
                    {slots > videoKeys.length &&

                      <div className="col-md-3 my-2">
                        <div className="CardBorder">
                          <div className="fileUploadCard">
                            <input
                              onChange={(e) => onFileInputChange(e.target.files[0])}
                              ref={fileInputRef}
                              type="file"
                              className="hidden"
                              accept="video/*"
                            />
                            <FileDrop
                              onDrop={(files, event) =>
                                setFiles(files[0])
                              }
                              onChange={(e) => onFileInputChange(e.target.files[0])}
                              onTargetClick={onTargetClick}
                              targetClassName="target"
                              className="filedrop"
                              draggingOverFrameClassName="filedropDrag"
                            >
                              <div>
                                <div className="iconCustomized text-center">
                                  {/* <AiOutlineUpload className="icon" /> */}
                                  <i className="fas fa-cloud-upload-alt dragDropIcon pt-2"></i>
                                </div>
                                <p className="p-2">
                                  Click or Drag and drop Video File
                                </p>
                              </div>
                            </FileDrop>
                            {videoProgress > 0 && videoProgress < 100 ? <div >

                              <MediaUploadProgressBar progress={videoProgress} />
                            </div> : null}
                          </div>
                        </div>
                      </div>
                    }
                  </div>

                  <span className="text-danger">{error_list.file}</span>
                </div>
                <div className="d-flex justify-content-center pb-4 px-4">
                  <button 
                  onClick={uploadVideo} 
                  disabled={slots>videoKeys.length ?true:false}
                  className="appealBtnLearning"
                  >
                    Upload
                  </button>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default LearningDragAndDrop;
